var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"mapShow",attrs:{"id":"mapShow"}}),(_vm.mapName !== 'china')?_c('div',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }